import classNames from 'classnames'
import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import QuestionIconWithTooltip from '~/shared/components/QuestionIconWithTooltip/QuestionIconWithTooltip'
import { TutorLevel } from '~/types/booking'

export default function TutorLevelItem({
  isSelected,
  onClick,
  value,
}: {
  isSelected: boolean
  onClick: (value: TutorLevel) => void
  value: TutorLevel
}): React.ReactElement {
  const { t } = useTranslation('booking')

  const tutorLevelBtnClasses = classNames('w-full py-2 rounded rounded-bl-none rounded-br-none', {
    'transition duration-300 bg-pink-light': isSelected,
    'border border-purple-semi-light border-b-none rounded -mb-2': !isSelected,
  })

  return (
    <div className="relative">
      <button className={tutorLevelBtnClasses} onClick={() => onClick(value)} type="button">
        <span className="font-medium text-blue-iris">{t(`tutorLevel.${value}`)}</span>
      </button>
      <Fragment>
        {value === TutorLevel.SENIOR && (
          <QuestionIconWithTooltip className="absolute top-1 -right-3 sm:right-4">
            {t('tutorLevel.seniorTutorTooltipText')}
          </QuestionIconWithTooltip>
        )}
      </Fragment>
    </div>
  )
}
